import React from "react";
import {
  Divider as ChakraDivider,
  DividerProps as ChakraDividerProps,
} from "@chakra-ui/react";
import { paletteOptions } from "./theme/themeOptions";

export interface DividerProps extends Omit<ChakraDividerProps, "colorScheme"> {
  palette?: keyof typeof paletteOptions;
}

export default function Divider(props: DividerProps) {
  const { palette, ...rest } = props;
  return <ChakraDivider colorScheme={palette} {...rest} />;
}
